import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { buildChartImage, shareOrDownload } from "../lib/shareImage";

export default function ShareChartButton({ chart, name, birthLine, brand }) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    const svgEl = document.querySelector("[data-testid=chart-wheel]");
    if (!svgEl) return;
    setBusy(true);
    try {
      const blob = await buildChartImage({ svgEl, chart, name, birthLine, brand });
      const slug = (name || "carta").toLowerCase().normalize("NFD").replace(/[^a-z0-9]+/g, "-");
      await shareOrDownload(blob, `carta-natal-${slug}.png`);
    } catch {
      toast.error("No se pudo crear la imagen");
    } finally { setBusy(false); }
  };

  return (
    <button data-testid="carta-share-image" onClick={run} disabled={busy}
      className="btn-ghost inline-flex items-center gap-2 text-sm mt-6">
      <Download size={16} />
      {busy ? "Creando imagen…" : "Descargar mi carta para historias"}
    </button>
  );
}
